/*
 * Public API Surface of app-manager
 */

export * from './lib/app-manager.service';
export * from './lib/app-manager.component';
export * from './lib/dialog/dialog.component';
export * from './lib/app-manager.module';
